import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Card, CardContent, Dialog, Grid, TextField } from "@material-ui/core";
import ConfirmationModal from "../../Components/Modal/Modal";
import ConfirmedActions from "../../Components/ConfirmedActions/ConfirmedActions";
import { useSelector } from "react-redux";
import { selectUserInformation } from "../../State/Slices/UserInformationSlice";
import { useAuth0 } from "@auth0/auth0-react";
import { resetPassword } from "../../Services/API/UserAccountActions";

function ProfilePage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    icon: {
      width: "10vmax",
      height: "10vmax",
      borderRadius: "50%",
      fontSize: "5vmax",
      color: "#fff",
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "10px",
    },
    sensitiveSection: {
      width: "100%",
      height: "25%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingTop: "20px",
    },
    sensitiveButton: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "none",
        width: "100%",
      },
      width: "200px",
    },
  }));

  const classes = useStyles();

  const [openModal, setOpenModal] = useState(false);
  const [color, setColor] = useState("");
  const user = useSelector(selectUserInformation);
  const { logout } = useAuth0();

  useEffect(() => {
    const val = user.email.length % 4;
    switch (true) {
      case val <= 0: {
        setColor("#DE7171");
        break;
      }
      case val <= 1: {
        setColor("#DEA871");
        break;
      }
      case val <= 2: {
        setColor("#DEDE71");
        break;
      }
      case val <= 3: {
        setColor("#66896B");
        break;
      }
      case val <= 4: {
        setColor("#71DEA8");
        break;
      }
      default: {
        setColor("#C2C2C2");
        break;
      }
    }
  }, [user.email.length, user.nickname]);

  const resetActions = [
    {
      key: "reset",
      question: "Are you sure you want to reset your password?",
      run: () => resetPassword(user.email),
    },
  ];

  return (
    <ConfirmedActions actions={resetActions}>
      {(start, busy) => (
        <>
          <div className="page-container">
            <Breadcrumb />
            <h1 className="page-title">Profile Page</h1>
            <div className={classes.root}>
              <Grid className={classes.cardContainer}>
                <Card className={classes.card}>
                  <CardContent>
                    <Grid container spacing={1} alignContent="center" justifyContent="center">
                      <Grid xs={12} sm={2} container alignContent="center" justifyContent="center">
                        <div className={classes.icon} style={{ backgroundColor: color }}>
                          {user?.nickname?.charAt(0)}
                        </div>
                      </Grid>
                      <Grid
                        xs={12}
                        sm={10}
                        container
                        spacing={6}
                        alignContent="center"
                        justifyContent="center"
                      >
                        <Grid item xs={12} sm={12}>
                          <TextField
                            placeholder="Username"
                            label="Username"
                            variant="standard"
                            fullWidth
                            required
                            value={user.nickname}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <TextField
                            placeholder="Email"
                            label="Email"
                            variant="standard"
                            fullWidth
                            required
                            value={user.email}
                            disabled
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <div className={classes.sensitiveSection}>
                  <Grid item xs={12} sm={12} container justifyContent="space-between">
                    <Button
                      style={{ backgroundColor: "#FF3620" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => setOpenModal(true)}
                    >
                      Log Out
                    </Button>
                    <Button
                      style={{ backgroundColor: "rgba(191,199,114,.8)" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={busy}
                      onClick={() => start("reset")}
                    >
                      Reset Password
                    </Button>
                  </Grid>
                </div>
              </Grid>
            </div>
          </div>
          <Dialog open={openModal} onClose={() => setOpenModal(false)}>
            <ConfirmationModal
              question="Are you sure you want to log out?"
              func={() => logout({ returnTo: window.location.origin })}
              closeModal={() => setOpenModal(false)}
            />
          </Dialog>
        </>
      )}
    </ConfirmedActions>
  );
}

export default ProfilePage;
